import {UUID} from 'node:crypto';

export enum DeckQuestionTopic {
  SPEND_VS_QUALITY = "SPEND_VS_QUALITY",
  CREATIVE = "CREATIVE",
  GEO = "GEO",
  TARGETING = "TARGETING",
  CHANNEL_DISTRIBUTION = "CHANNEL_DISTRIBUTION",
}

export enum DeckQuestionTopicDisplay {
  SPEND_VS_QUALITY = "Spend vs. Quality",
  CREATIVE = "Creative Strategy",
  GEO = "Geo-related Insights",
  TARGETING = "Audience and Targeting",
  CHANNEL_DISTRIBUTION = "Channel Distribution",
}

export interface DeckQuestion {
  id: string;
  mainQuestion: string;
  prompt: string;
  topic: DeckQuestionTopic;
}

export interface DeckGenerationPayload {
  questionIds: UUID[];
  ownQuestions?: OwnQuestionPayload[];
  accountKey: string;
  brandKey: string;
  competitors: string[];
}

export interface OwnQuestionPayload {
  question: string;
  topic: DeckQuestionTopic;
}

export type GroupedDeckQuestionsResponse = Partial<Record<DeckQuestionTopic, DeckQuestion[]>>;

export interface DeckQuestionsPayload {
  questions: GroupedDeckQuestionsResponse;
  total: number;
}

export interface DeckGenerationResponse {
  success: boolean;
}
